import formStyles from '../LoginContent/index.module.scss';
import classNames from 'classnames';

export const SupportLink = () => {
  return (
    <div
      className={classNames(
        formStyles.supportLink,
        'leading-5 text-sm font-normal text-neutrals-n-400 flex flex-col items-center text-center',
      )}
    >
      Still experiencing issues reseting password?{' '}
      <a
        href="mailto:support@onestep.co"
        target="_blank"
        className="cursor-pointer hover:underline"
      >
        support@onestep.co
      </a>
    </div>
  );
};
